import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Container, Box, Typography, Avatar, useTheme, alpha } from "@mui/material";
import FolderIcon from '@mui/icons-material/Folder';
import DashboardLayout from "../../common/layouts/dashboard";
import { RootState } from "../../core/store/store";
import { BillingInactiveDialog } from "../billing/billing-inactive-dialog";
import ProjectsFilter from "./projects-filter";
import ProjectsHeader from "./projects-header";
import ProjectsList from "./projects-list";

const Projects = () => {
  const theme = useTheme();
  //Show projects if they have a Wordform plan
  const authState = useSelector((state: RootState) => state.auth);
  const noWordformPlan = authState.plan?.selected == null;

  useEffect(() => {
    document.title = "Wordform AI - Projects";
  }, []);
  
  return (
    <DashboardLayout active={"projects"} name="Projects">
      <BillingInactiveDialog open={noWordformPlan} />
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Box sx={{ mb: 3 }}>
          <ProjectsHeader />
        </Box>
        <Box sx={{ mb: 2 }}>
          <ProjectsFilter />
        </Box>
        <ProjectsList />
      </Container>
    </DashboardLayout>
  );
};

export default Projects;